import { render, staticRenderFns } from "./shortcode.vue?vue&type=template&id=1f449c0a&"
import script from "./shortcode.vue?vue&type=script&lang=js&"
export * from "./shortcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f449c0a')) {
      api.createRecord('1f449c0a', component.options)
    } else {
      api.reload('1f449c0a', component.options)
    }
    module.hot.accept("./shortcode.vue?vue&type=template&id=1f449c0a&", function () {
      api.rerender('1f449c0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/form-template/shortcode.vue"
export default component.exports